import ToolMark from './ToolMark';
import ColorPickerToolButton from '../../../components/ColorPicker/ColorPickerToolButton/ColorPickerToolButton';

// Toggles a text highlight mark (background color style) on the currently selected elements.
class ToolTextHighlight extends ToolMark {
  static toolName = 'Text highlight';
  static iconClass = 'fa-regular fa-highlighter';
  static mark = 'textHighlight' as const;

  static toolbarSubmenu() {
    return ColorPickerToolButton;
  }
}

export default ToolTextHighlight;
